import * as Types from './types';
export function setAllowBackNavigation(allowBackNavigation) {
    var action = {
        type: Types.SET_ALLOW_BACK_NAVIGATION,
        allowBackNavigation: allowBackNavigation,
    };
    return action;
}
;
